import ProductCard from '@/components/cards/ProductCard/index.vue';
import { globalLoader } from '@/helpers/variables';

export default {
  name: 'ProfilePromo',
  components: {
    ProductCard
  },
  data() {
    return {
      promocode: 'SKINLOVE14'
    };
  },
  mounted() {
    globalLoader(false);
  },
  computed: {},
  methods: {
    onCopyPromocode() {
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(this.promocode);
      } else {
        const textarea = document.createElement('textarea');
        textarea.value = this.promocode;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
      }
      this.$toasted.success(this.$t('toast.promocodeCopy'));
    }
  }
};
